var _path, _path2, _polygon, _polygon2, _polygon3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,379.14H61.93c7.49-6.88,25.12-6.46,25.12-6.46s-12.23-13.13-7.72-21.56,16.59,10.05,16.59,10.05-15.19-27.49-9.54-34.34,20.84,30.1,20.84,30.1-9.23-39.11-3.68-40.22,11.35,37.09,11.35,37.09-2-34.92,2.67-33.92S120,366.44,120,366.44s4.7-23.25,6.7-15.83-2,23.31-2,23.31A6,6,0,0,1,131,379.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.24,379.14h89.69c-9.72-8.93-32.62-8.38-32.62-8.38s15.88-17.07,10-28-21.53,13-21.53,13,19.72-35.7,12.38-44.6-27.05,39.1-27.05,39.1,12-50.79,4.77-52.23-14.73,48.16-14.73,48.16,2.59-45.34-3.48-44.05-3.12,60.47-3.12,60.47-6.1-30.19-8.71-20.56,2.61,30.27,2.61,30.27C169.47,372.44,167.74,376.55,167.24,379.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.48,379.14h69.07c-7.49-6.88-25.12-6.46-25.12-6.46s12.23-13.13,7.72-21.56-16.59,10.05-16.59,10.05,15.19-27.49,9.54-34.34-20.84,30.1-20.84,30.1,9.23-39.11,3.68-40.22-11.35,37.09-11.35,37.09,2-34.92-2.67-33.92-2.41,46.56-2.41,46.56-4.7-23.25-6.7-15.83,2,23.31,2,23.31A6,6,0,0,0,249.48,379.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.59,379.14c-3.06-47-10.43-167.27-9.39-218.15l-4.91-.33s-4.9,153.28-2.22,218.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.89 182.01 116.5 171.76 117.76 165.4 125.33 153.85 126.96 153.26 119.49 166.32 119.19 170.7 130.54 168.62 135.29 159.85 140.3 155.92 141.05 157.22 136.78 161.03 133.28 170.39 117.74 174.3 101.53 193.95 103.89 182.01",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.42 172.48 100.81 176.78 87.18 163.73 78.78 162.07 72.3 157.6 72.74 157.17 78.9 161.09 85.72 161.41 79.26 153.38 72.9 148.75 73.33 148.48 79.71 152.61 90.21 163.24 89.17 153.52 86.74 149.39 86.5 148.25 89.56 152.75 97.54 150.12 98.21 150.62 90.02 153.53 91.5 164.25 101.42 172.48",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.79,155.74c.31-1.74-2.45-3-5.43-3.19a37.68,37.68,0,0,1-6.51-1c.28-.62.08-1.37.48-2.45.87-2.36.4-3.95-2.21-6s-5.24-1.65-11-1-4.92-1.92-10.08-4.39-23.13-1.44-26.44.86c-2,1.38-9.75.57-11.9,3.95S58.84,145,60.52,148s3.71,3.07,3.37,8,4.13,3.28,8.59,5.13,3.86-1.62,6.78-1.84,2.11-.52,5.11-1.91,2.58.36,7.34,2.75c2.62,1.32,3.59-.28,4.4-2,.49,1.11-.06,2.73.92,4.61.79,1.5,3.94,1.84,6.94,1.56,3.29,6.24,4.7,1,8.82,1.48,4.35.47,10.89-3,13.95-3.33s3.27-1.15,6.43,1.31,16.81-2.34,18.1-4.81S146.48,157.48,146.79,155.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,379.14c-2.9-45.95-8-134.65-7.23-174.23l-4.2-.28s-3.65,113.88-2.28,174.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.62 222.89 205.4 214.12 206.48 208.68 212.95 198.81 214.34 198.3 207.96 209.46 207.7 213.22 217.41 211.43 221.47 203.94 225.76 200.57 226.4 201.68 222.75 204.94 219.75 212.95 206.46 216.29 192.59 233.09 194.62 222.89",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.5 214.74 191.98 218.41 180.32 207.25 173.14 205.83 167.6 202.01 167.98 201.64 173.24 204.99 179.07 205.27 173.55 198.4 168.11 194.44 168.48 194.21 173.94 197.74 182.92 206.83 182.03 198.52 179.94 194.98 179.74 194.01 182.36 197.86 189.19 195.61 189.76 196.04 182.76 198.53 184.02 207.7 192.5 214.74",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.31,200.42c.26-1.49-2.1-2.55-4.64-2.73a31.73,31.73,0,0,1-5.58-.88c.24-.53.07-1.18.41-2.1.75-2,.35-3.37-1.88-5.13s-4.49-1.41-9.38-.84-4.2-1.64-8.62-3.75-19.78-1.23-22.61.73c-1.7,1.18-8.34.5-10.18,3.39s-12.74,2.15-11.3,4.66,3.16,2.63,2.88,6.83,3.52,2.8,7.34,4.38,3.31-1.38,5.8-1.57,1.81-.44,4.37-1.63,2.21.3,6.28,2.35c2.24,1.13,3.07-.24,3.77-1.67.41.95-.06,2.34.78,3.94.67,1.29,3.37,1.58,5.93,1.34,2.81,5.34,4,.88,7.55,1.27,3.71.4,9.31-2.54,11.93-2.85s2.79-1,5.5,1.12,14.38-2,15.48-4.12S231,201.91,231.31,200.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.82,333.31c-.93-6.58-18.44-141.87-22.41-225.81h-6.56s3.69,169.59,14.68,231.41Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.92,379.14H261.05c-18.89-10.3-63.33-9.66-63.33-9.66s30.83-19.67,19.46-32.27-41.81,15-41.81,15,38.28-41.14,24-51.4-52.53,45.06-52.53,45.06,23.25-58.54,9.27-60.2-28.61,55.51-28.61,55.51,5-52.26-6.75-50.77-6.07,69.69-6.07,69.69-11.84-34.79-16.9-23.7,5.08,34.89,5.08,34.89C91.23,371.42,87.88,376.16,86.92,379.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.57 135.59 163.43 120.82 164.53 112.24 173.57 96.18 175.68 95.25 166.91 113.3 166.91 119.16 181.83 115.37 187.37 103.28 193.68 97.58 194.79 99.24 189.45 104.7 185.64 117.48 165.31 124.09 145.49 151.69 147.57 135.59",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.41 123.14 142.99 128.9 123.67 112.77 112.34 111.31 103.31 105.94 103.87 105.33 112.41 109.99 121.52 109.82 112.19 99.7 103.31 94.11 103.87 93.71 112.73 98.64 127.66 111.84 125.4 98.99 121.79 93.71 121.37 92.22 125.86 97.94 136.24 93.71 137.17 94.32 126.54 98.94 129.47 113.07 143.41 123.14",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.3,96.76c.25-2.34-3.53-3.75-7.51-3.75a51.65,51.65,0,0,1-8.76-.78c.31-.86,0-1.85.41-3.32.95-3.21.19-5.29-3.48-7.78s-7.13-1.73-14.68-.32-6.71-2.11-13.81-4.93-30.91.17-35.11,3.52c-2.52,2-12.93,1.64-15.49,6.34s-19.6,4.69-17.1,8.44S92,97.94,92,104.51s5.78,4,11.89,6,5-2.5,8.86-3.06,2.76-.88,6.63-3,3.46.24,10,3c3.61,1.52,4.76-.69,5.69-3,.74,1.44.17,3.65,1.64,6.06,1.18,1.93,5.41,2.09,9.37,1.45,4.94,8,6.35,1,11.88,1.18,5.82.23,14.22-4.93,18.27-5.69s4.24-1.82,8.68,1.16,22.16-4.62,23.65-8S202.05,99.11,202.3,96.76Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,106.08a6.77,6.77,0,0,0-6.77-6.77,6.6,6.6,0,0,0-1.94.29,14.34,14.34,0,0,0-14.18-16.41,14.41,14.41,0,0,0-2.64.25,12.52,12.52,0,0,0-23.22,6.33h-.21a11.55,11.55,0,1,0,0,23.09h42.38A6.77,6.77,0,0,0,426,106.08Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.92,169.28a6.76,6.76,0,0,0-6.77-6.76,6.89,6.89,0,0,0-1.94.28A14.34,14.34,0,0,0,257,146.39a14.41,14.41,0,0,0-2.64.25A12.53,12.53,0,0,0,231.16,153H231a11.55,11.55,0,1,0,0,23.09h42.38A6.76,6.76,0,0,0,279.92,169.28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.15,252.69a6.77,6.77,0,0,0-6.77-6.77,6.6,6.6,0,0,0-1.94.29,14.34,14.34,0,0,0-14.18-16.41,14.41,14.41,0,0,0-2.64.25,12.52,12.52,0,0,0-23.22,6.33h-.21a11.54,11.54,0,0,0,0,23.08h42.38A6.77,6.77,0,0,0,437.15,252.69Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.81,222.15a4.1,4.1,0,0,0-4.09-4.09,4.16,4.16,0,0,0-1.18.18A8.67,8.67,0,0,0,85,208.32a8.32,8.32,0,0,0-1.59.15,7.57,7.57,0,0,0-14,3.83h-.13a7,7,0,0,0,0,14H94.83A4.09,4.09,0,0,0,98.81,222.15Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.73,93.73a4.09,4.09,0,0,0-5.26-3.92,8.67,8.67,0,0,0-8.57-9.92,9.33,9.33,0,0,0-1.6.15,7.57,7.57,0,0,0-14,3.83h-.12a7,7,0,1,0,0,14h25.62A4.08,4.08,0,0,0,315.73,93.73Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tree--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.25,400s-3.25-.17-3.57-9,5.4-11.26,9.8-10.17c0,0-.64-6.33,2.21-6.09s2.66,4.45,2.66,4.45,1-9,4.87-9,0,10.61,0,10.61,5.39-2.59,7.37,0-2.47,5.62-2.47,5.62,7,2.28,4.06,9.52c0,0,4.87.76,6.23,4,0,0-.39-6.55,1.37-6.11s1.36,6.18,1.36,6.18,2.92-6.3,5.45-4.08-1.16,7.57-1.16,7.57,4.87-2.36,5.64.77-2.72,4.3-2.72,4.3,5.06-1.17,5.06,4.64c0,0,9.74-.93,12.08,4.29h-58Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.25,400s-3.25-.17-3.57-9,5.4-11.26,9.8-10.17c0,0-.64-6.33,2.21-6.09s2.66,4.45,2.66,4.45,1-9,4.87-9,0,10.61,0,10.61,5.39-2.59,7.37,0-2.47,5.62-2.47,5.62,7,2.28,4.06,9.52c0,0,4.87.76,6.23,4,0,0-.39-6.55,1.37-6.11s1.36,6.18,1.36,6.18,2.92-6.3,5.45-4.08-1.16,7.57-1.16,7.57,4.87-2.36,5.64.77-2.72,4.3-2.72,4.3,5.06-1.17,5.06,4.64c0,0,9.74-.93,12.08,4.29h-58Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.61,309c-1.4,23-9,108-9,108l54.91.51L373.08,263.92l24.64-7.52,5.17-14.93L423.7,229.7l10.17-15.62-3.93-1-11.23,14.42-13.1,2.85,5.61-13.29H405l-15.6,30.78-16,3.28-1.46-56c-16.08,7.51-21.22-5-21.22-5s-4.16,87.66-6.5,94.28h0a34.4,34.4,0,0,1-6.57-4.75,76.8,76.8,0,0,1-14-16.56l-1-1.65h-5Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M342.61,309c-1.4,23-9,108-9,108l54.91.51L373.08,263.92l24.64-7.52,5.17-14.93L423.7,229.7l10.17-15.62-3.93-1-11.23,14.42-13.1,2.85,5.61-13.29H405l-15.6,30.78-16,3.28-1.46-56c-16.08,7.51-21.22-5-21.22-5s-4.16,87.66-6.5,94.28h0a34.4,34.4,0,0,1-6.57-4.75,76.8,76.8,0,0,1-14-16.56l-1-1.65h-5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M400.49,237.32l-6.69,12.9-20.93,5.3s.07-3.29.41-7.51l.09,3.16,16-3.28L405,217.11h6.24l-5.61,13.29,13.1-2.85,11.23-14.42.55.13-8.65,13.09Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.36 341.56 375.3 417.39 366.59 417.31 366.59 357.46 370.36 341.56",
    style: {
      fill: "#00A848",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.61,309l-25-47.51h5l1,1.65a76.8,76.8,0,0,0,14,16.56,34.4,34.4,0,0,0,6.57,4.75c2.34-6.62,6.5-94.28,6.5-94.28a12.92,12.92,0,0,0,8.44,7q.35,42.47.71,84.94c1.77-4,3.31-7.89,3.46-12.08.53,11.6,1.24,24.07,1.19,35.52l-9.62,35.49L353,417.18,333.64,417S341.21,332,342.61,309Z",
    style: {
      fill: "#00A848",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.81,160.66c-8,2.86-13.53,11.33-13.28,19.84a22.8,22.8,0,0,0,13.87,19.76,25.17,25.17,0,0,0,24.19-3.19c.35,8.17,5.93,17.05,13.72,19.52a20.59,20.59,0,0,0,22-6.88c21,13.19,94.5,18.08,107.42-38.09,2.66-11.6-3.8-23.88-13.27-31.09s-21.51-10.16-33.32-11.61c-11.21-17.85-36.07-27.6-57-24.8s-39.46,18.61-45.57,38.78C278.28,143,280.5,162.09,280.81,160.66Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M280.81,160.66c-8,2.86-13.53,11.33-13.28,19.84a22.8,22.8,0,0,0,13.87,19.76,25.17,25.17,0,0,0,24.19-3.19c.35,8.17,5.93,17.05,13.72,19.52a20.59,20.59,0,0,0,22-6.88c21,13.19,94.5,18.08,107.42-38.09,2.66-11.6-3.8-23.88-13.27-31.09s-21.51-10.16-33.32-11.61c-11.21-17.85-36.07-27.6-57-24.8s-39.46,18.61-45.57,38.78C278.28,143,280.5,162.09,280.81,160.66Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M306.74,271.15A11.24,11.24,0,0,0,326.85,268c5,3.5,12.66,2.64,17.7-.77A15.11,15.11,0,0,0,338,239.73,18,18,0,0,0,329.57,226a19.61,19.61,0,0,0-16.78-1.77A20.55,20.55,0,0,0,294.93,230c-3.37,3.27-5.61,7.91-5.22,12.59s3.81,9.17,8.42,10.06a13.79,13.79,0,0,0-.48,10.95C299.14,267.08,303.16,269.82,306.74,271.15Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.74,271.15A11.24,11.24,0,0,0,326.85,268c5,3.5,12.66,2.64,17.7-.77A15.11,15.11,0,0,0,338,239.73,18,18,0,0,0,329.57,226a19.61,19.61,0,0,0-16.78-1.77A20.55,20.55,0,0,0,294.93,230c-3.37,3.27-5.61,7.91-5.22,12.59s3.81,9.17,8.42,10.06a13.79,13.79,0,0,0-.48,10.95C299.14,267.08,303.16,269.82,306.74,271.15Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.56,186.23a11.24,11.24,0,0,0-14.18,14.6c-6.08.19-11.71,5.5-13.69,11.25a15.1,15.1,0,0,0,21.71,18.07,18,18,0,0,0,15,5.9,19.65,19.65,0,0,0,14.49-8.66,20.56,20.56,0,0,0,10.84-15.31c.73-4.63-.26-9.69-3.39-13.2s-8.55-5-12.77-3a13.79,13.79,0,0,0-6.19-9C421.09,184.93,416.22,185.15,412.56,186.23Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.56,186.23a11.24,11.24,0,0,0-14.18,14.6c-6.08.19-11.71,5.5-13.69,11.25a15.1,15.1,0,0,0,21.71,18.07,18,18,0,0,0,15,5.9,19.65,19.65,0,0,0,14.49-8.66,20.56,20.56,0,0,0,10.84-15.31c.73-4.63-.26-9.69-3.39-13.2s-8.55-5-12.77-3a13.79,13.79,0,0,0-6.19-9C421.09,184.93,416.22,185.15,412.56,186.23Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.45,415.29S355.28,402.22,359.11,400s17.27,10.85,17.27,10.85-14.86-21.74-11.19-26.1,13.56,17.72,13.56,17.72-6.72-25.24-2-28,6.47,25.29,6.47,25.29,1.85-30.4,10.55-30-4,30-4,30,12.27-17.59,16.62-12.6-13.85,19-13.85,19,13.61-6.39,14.52-1.65-15,9.79-15,9.79,5.11,1.47,6.3,3.19H371.18S370.74,416.2,375.45,415.29Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.45,415.29S355.28,402.22,359.11,400s17.27,10.85,17.27,10.85-14.86-21.74-11.19-26.1,13.56,17.72,13.56,17.72-6.72-25.24-2-28,6.47,25.29,6.47,25.29,1.85-30.4,10.55-30-4,30-4,30,12.27-17.59,16.62-12.6-13.85,19-13.85,19,13.61-6.39,14.52-1.65-15,9.79-15,9.79,5.11,1.47,6.3,3.19H371.18S370.74,416.2,375.45,415.29Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stone--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.67,364.63c-.07-.36-6.83-35.43-13.43-40.1-6.41-4.52-12,1.69-12.2,2l-.75-.65c.06-.08,6.39-7.15,13.52-2.11,6.94,4.89,13.56,39.26,13.84,40.72Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.16,367.52c0-.24-2.5-24.35-10.27-31.75-1.88-1.79-3.72-2.49-5.47-2.08-4.16.95-6.73,7.68-6.75,7.75l-.94-.35c.11-.3,2.78-7.3,7.46-8.38,2.1-.48,4.25.3,6.39,2.33,8,7.66,10.48,31.38,10.58,32.38Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5,328.37s4.52-.91,5.39,3-7.52,16.31-7.52,16.31-7.62-1.47-7.62-11.49S106,326.14,107.5,328.37Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5,328.37s4.52-.91,5.39,3-7.52,16.31-7.52,16.31-7.62-1.47-7.62-11.49S106,326.14,107.5,328.37Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.83,335.93s1.82-2-.57-2.49S81.84,335,83.45,346c0,0,13.24.11,14.18-4.33S95.83,335.93,95.83,335.93Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.83,335.93s1.82-2-.57-2.49S81.84,335,83.45,346c0,0,13.24.11,14.18-4.33S95.83,335.93,95.83,335.93Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.83,317.08s-.51-2,1.27-1.48,8.55,5.86,3.49,12.72c0,0-9-4.7-8-8S112.83,317.08,112.83,317.08Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.83,317.08s-.51-2,1.27-1.48,8.55,5.86,3.49,12.72c0,0-9-4.7-8-8S112.83,317.08,112.83,317.08Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.18,371.82l-1-.27c.12-.41,11.66-41.48,32.53-52.54l.47.88C290.72,330.76,279.29,371.41,279.18,371.82Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.37,367.18l-.91-.42c.21-.43,20.12-43.95,13.26-57.77l.89-.44C299.69,322.79,280.2,365.38,279.37,367.18Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.59,370.33l-1-.29c.68-2.26,16.67-55.37,26.9-61.9l.54.84C295.15,315.31,278.75,369.78,278.59,370.33Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.32,310.7s3,.79,3.43-1-8.75-10.51-18-5.72c0,0,1.4,8.66,7.32,11S295.32,310.7,295.32,310.7Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.32,310.7s3,.79,3.43-1-8.75-10.51-18-5.72c0,0,1.4,8.66,7.32,11S295.32,310.7,295.32,310.7Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.29,308.51s-3.08.26-3.19-1.62,10.45-8.83,18.69-2.5c0,0-2.9,8.28-9.14,9.59S302.29,308.51,302.29,308.51Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.29,308.51s-3.08.26-3.19-1.62,10.45-8.83,18.69-2.5c0,0-2.9,8.28-9.14,9.59S302.29,308.51,302.29,308.51Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.06,316.82s-1.36-2.35,1.07-2.31,12.82,4.28,8.95,14.69c0,0-13-2.65-13-7.18S312.06,316.82,312.06,316.82Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.06,316.82s-1.36-2.35,1.07-2.31,12.82,4.28,8.95,14.69c0,0-13-2.65-13-7.18S312.06,316.82,312.06,316.82Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.41,322.7s.57-2,1.85-.64,4.47,9.34-3.33,12.76c0,0-5.45-8.56-2.95-11S302.41,322.7,302.41,322.7Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.41,322.7s.57-2,1.85-.64,4.47,9.34-3.33,12.76c0,0-5.45-8.56-2.95-11S302.41,322.7,302.41,322.7Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.93,323.38s1-1.84-.87-1.75-9.73,3.57-6.52,11.46c0,0,9.88-2.33,9.77-5.8S91.93,323.38,91.93,323.38Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.93,323.38s1-1.84-.87-1.75-9.73,3.57-6.52,11.46c0,0,9.88-2.33,9.77-5.8S91.93,323.38,91.93,323.38Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.68,391.53s-6.6-.26-7.25-13.57,11-16.86,19.91-15.23c0,0-1.31-9.48,4.49-9.13s5.4,6.68,5.4,6.68,2-13.44,9.89-13.45,0,15.9,0,15.9,10.95-3.88,15,0-5,8.42-5,8.42,14.19,3.41,8.26,14.27c0,0,9.89,1.14,12.66,6,0,0-.79-9.81,2.77-9.15s2.76,9.26,2.76,9.26,5.94-9.45,11.08-6.11-2.37,11.34-2.37,11.34,9.89-3.54,11.47,1.15-5.54,6.45-5.54,6.45,10.29-1.76,10.29,6.95c0,0,19.78-1.4,24.53,6.42H268.08Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.68,391.53s-6.6-.26-7.25-13.57,11-16.86,19.91-15.23c0,0-1.31-9.48,4.49-9.13s5.4,6.68,5.4,6.68,2-13.44,9.89-13.45,0,15.9,0,15.9,10.95-3.88,15,0-5,8.42-5,8.42,14.19,3.41,8.26,14.27c0,0,9.89,1.14,12.66,6,0,0-.79-9.81,2.77-9.15s2.76,9.26,2.76,9.26,5.94-9.45,11.08-6.11-2.37,11.34-2.37,11.34,9.89-3.54,11.47,1.15-5.54,6.45-5.54,6.45,10.29-1.76,10.29,6.95c0,0,19.78-1.4,24.53,6.42H268.08Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.06,391.53s4.87-.26,5.35-13.57-8.09-16.86-14.69-15.23c0,0,1-9.48-3.31-9.13s-4,6.68-4,6.68-1.46-13.44-7.3-13.45,0,15.9,0,15.9-8.07-3.88-11,0,3.71,8.42,3.71,8.42-10.47,3.41-6.09,14.27c0,0-7.3,1.14-9.34,6,0,0,.58-9.81-2-9.15s-2,9.26-2,9.26-4.37-9.45-8.17-6.11,1.75,11.34,1.75,11.34-7.29-3.54-8.46,1.15,4.09,6.45,4.09,6.45-7.59-1.76-7.59,6.95c0,0-14.59-1.4-18.1,6.42h87Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.06,391.53s4.87-.26,5.35-13.57-8.09-16.86-14.69-15.23c0,0,1-9.48-3.31-9.13s-4,6.68-4,6.68-1.46-13.44-7.3-13.45,0,15.9,0,15.9-8.07-3.88-11,0,3.71,8.42,3.71,8.42-10.47,3.41-6.09,14.27c0,0-7.3,1.14-9.34,6,0,0,.58-9.81-2-9.15s-2,9.26-2,9.26-4.37-9.45-8.17-6.11,1.75,11.34,1.75,11.34-7.29-3.54-8.46,1.15,4.09,6.45,4.09,6.45-7.59-1.76-7.59,6.95c0,0-14.59-1.4-18.1,6.42h87Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.64,415.51S106.8,402.44,103,400.24,85.7,411.08,85.7,411.08s14.86-21.74,11.19-26.1S83.33,402.7,83.33,402.7s6.72-25.24,2-28S78.84,400,78.84,400,77,369.59,68.29,370s4,30,4,30S60,382.39,55.64,387.39s13.84,19,13.84,19S55.87,400,55,404.76s15,9.79,15,9.79-5.12,1.47-6.3,3.18H90.91S91.34,416.43,86.64,415.51Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.64,415.51S106.8,402.44,103,400.24,85.7,411.08,85.7,411.08s14.86-21.74,11.19-26.1S83.33,402.7,83.33,402.7s6.72-25.24,2-28S78.84,400,78.84,400,77,369.59,68.29,370s4,30,4,30S60,382.39,55.64,387.39s13.84,19,13.84,19S55.87,400,55,404.76s15,9.79,15,9.79-5.12,1.47-6.3,3.18H90.91S91.34,416.43,86.64,415.51Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.73,417.73s23.2-85.37,27.42-88.53,28.29-12.07,28.29-12.07,58.55,9.78,67.35,8.81,37.08-6.41,41.14,0S281,370.87,281,370.87l22.49,9.49,14.25,37.37Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.74,417.73h-221s23.09-85,27.39-88.52l0,0a31.57,31.57,0,0,1,4.73-2.55c8.36-3.89,23.56-9.51,23.56-9.51s58.55,9.78,67.35,8.81,37.08-6.42,41.14,0c.86,1.37,2.27,4.19,3.95,7.79C271.08,347,281,370.86,281,370.86l22.49,9.5Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.88,333.73l-8.73,8.64L233.4,337l-25.74,5.35,1.65,9.95-9.37,11.16,3.33-11.16L196,340.05s-29.62,1.8-37.35,0c-4.85-1.13-19.52-8.27-29.74-13.41,8.36-3.89,23.56-9.51,23.56-9.51s58.55,9.78,67.35,8.81,37.08-6.42,41.14,0C261.79,327.31,263.2,330.13,264.88,333.73Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.74,417.73h-221s23.09-85,27.39-88.52l0,0-14.24,66.24,7.12,11,17.5-13.28L148,400.61l18.62-3.76,1.85-9,26.38-17.35-16.56,15.34,5.83,17.5,25.35,4.37h28L249,400l-3.86-15.7-5.83-9.1,29.55-.07-12.58,7.79,4.64,13.83,14.23,6.6,16.54-10.21,6.74,19.48Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.2,417.73h36.63s-7.29-11.16-10.4-9.74c-4.05,1.84-7.05-8.27-11.53-5.88-1.58.85-.8,3.55-1.8,4.64-1.64,1.8-3.73,1.45-5.71,2.44C291.5,411.13,290.12,413.69,288.2,417.73Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.2,417.73h36.63s-7.29-11.16-10.4-9.74c-4.05,1.84-7.05-8.27-11.53-5.88-1.58.85-.8,3.55-1.8,4.64-1.64,1.8-3.73,1.45-5.71,2.44C291.5,411.13,290.12,413.69,288.2,417.73Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.83,414.62s-2.41-13.95-.75-16,1.95,7.61,1.95,7.61,5.58-20.16,9.15-20.26S327,403.46,327,403.46s15.26-24.94,19.69-22.62-16,24.43-16,24.43,11.16-9.61,13.62-6.89-12.39,11-12.39,11,6.55-1.47,6.54.71S327.38,415.86,320.83,414.62Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.83,414.62s-2.41-13.95-.75-16,1.95,7.61,1.95,7.61,5.58-20.16,9.15-20.26S327,403.46,327,403.46s15.26-24.94,19.69-22.62-16,24.43-16,24.43,11.16-9.61,13.62-6.89-12.39,11-12.39,11,6.55-1.47,6.54.71S327.38,415.86,320.83,414.62Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.63,412.63s-11.47-2.08-12.58-3.94,6.43.64,6.43.64-14-10-13.09-12.8,12.33,8.21,12.33,8.21-15-18.84-11.93-21.62,14.39,19.26,14.39,19.26-4.28-11.35-1.49-12.49,5,12.7,5,12.7.71-5.48,2.39-4.86S321.44,407.91,318.63,412.63Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.63,412.63s-11.47-2.08-12.58-3.94,6.43.64,6.43.64-14-10-13.09-12.8,12.33,8.21,12.33,8.21-15-18.84-11.93-21.62,14.39,19.26,14.39,19.26-4.28-11.35-1.49-12.49,5,12.7,5,12.7.71-5.48,2.39-4.86S321.44,407.91,318.63,412.63Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.77,411.1s-11.08-11.09-10.88-14,6.62,5.64,6.62,5.64-7.81-21.81-4.64-24.18,7.32,18.54,7.32,18.54-2.1-32.32,3.4-33,1.12,32.3,1.12,32.3,4-15.81,7.94-14.93-4.2,17.87-4.2,17.87,5-5.51,6.37-3.53S324.49,408,317.77,411.1Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.77,411.1s-11.08-11.09-10.88-14,6.62,5.64,6.62,5.64-7.81-21.81-4.64-24.18,7.32,18.54,7.32,18.54-2.1-32.32,3.4-33,1.12,32.3,1.12,32.3,4-15.81,7.94-14.93-4.2,17.87-4.2,17.87,5-5.51,6.37-3.53S324.49,408,317.77,411.1Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.34,417.73h29.19s-5.81-8.89-8.29-7.76c-3.22,1.47-5.61-6.59-9.18-4.68-1.26.67-.65,2.82-1.44,3.69-1.31,1.44-3,1.16-4.55,1.95C307,412.47,305.87,414.51,304.34,417.73Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,417.73H85.4s7.3-11.16,10.41-9.74c4,1.84,7-8.27,11.52-5.88,1.58.85.81,3.55,1.81,4.64,1.64,1.8,3.73,1.45,5.71,2.44C118.74,411.13,120.12,413.69,122,417.73Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,417.73H85.4s7.3-11.16,10.41-9.74c4,1.84,7-8.27,11.52-5.88,1.58.85.81,3.55,1.81,4.64,1.64,1.8,3.73,1.45,5.71,2.44C118.74,411.13,120.12,413.69,122,417.73Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.41,414.62s2.4-13.95.74-16-2,7.61-2,7.61S82.62,386.07,79.05,386s4.24,17.49,4.24,17.49S68,378.52,63.59,380.84s16,24.43,16,24.43-11.17-9.61-13.63-6.89,12.4,11,12.4,11-6.55-1.47-6.54.71S82.85,415.86,89.41,414.62Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.41,414.62s2.4-13.95.74-16-2,7.61-2,7.61S82.62,386.07,79.05,386s4.24,17.49,4.24,17.49S68,378.52,63.59,380.84s16,24.43,16,24.43-11.17-9.61-13.63-6.89,12.4,11,12.4,11-6.55-1.47-6.54.71S82.85,415.86,89.41,414.62Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.65,415.28s8.73-7.73,8.72-9.9-5.17,3.89-5.17,3.89,6.8-15.83,4.56-17.73S102.47,405,102.47,405s3-23.88-1-24.67-2.32,23.92-2.32,23.92-2.23-11.92-5.2-11.44,2.29,13.45,2.29,13.45-3.45-4.32-4.57-2.91S95.81,412.69,100.65,415.28Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.65,415.28s8.73-7.73,8.72-9.9-5.17,3.89-5.17,3.89,6.8-15.83,4.56-17.73S102.47,405,102.47,405s3-23.88-1-24.67-2.32,23.92-2.32,23.92-2.23-11.92-5.2-11.44,2.29,13.45,2.29,13.45-3.45-4.32-4.57-2.91S95.81,412.69,100.65,415.28Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.9,417.73H76.7s5.82-8.89,8.3-7.76c3.22,1.47,5.61-6.59,9.18-4.68,1.26.67.64,2.82,1.43,3.69,1.31,1.44,3,1.16,4.56,1.95C103.27,412.47,104.37,414.51,105.9,417.73Z",
    style: {
      fill: "#00A848"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.87,226s-33.62-5.24-40-2.49-8.53,12.64-8.53,12.64-1.15,2,2.33,2.26c0,0-14.23,35.45-9.73,42.24s49.82,9.51,56,6.18S195.79,228.53,174.87,226Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.67,259.82s4.45,10.33,5.45,11.77,23.15,11.62,23.15,11.62a19.55,19.55,0,0,1,5.41,0c2.73.43,6.49,1.58,6.83,2s-4.11,6.89-4.11,6.89-8.85.55-10-2.95c0,0-22.19-8.24-24.77-10.4s-9.76-14.92-9.76-14.92Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.3,237.2c4.16,2.48,10.67,29.18,12.07,32.35s18.4,10.88,18.4,10.88l-7.54,7.22S194,280,191.86,277.86s-10.74-24.33-10.74-24.33Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.92,298.22s70.12-10.07,73.82,5.31c3.91,16.27-52.39,27.24-86,28.39s-43.33-6.24-37.93-47.82l45.4-.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.92,298.22s70.12-10.07,73.82,5.31c3.91,16.27-52.39,27.24-86,28.39s-43.33-6.24-37.93-47.82l45.4-.11Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25,322.06a.21.21,0,0,1-.25,0,.17.17,0,0,1-.06-.21c.11-.37,1.22-3.61,2.35-3.95a.7.7,0,0,1,.67.2,1.15,1.15,0,0,1,.4,1.09,3,3,0,0,1-1.05,1.52A12.24,12.24,0,0,1,250.25,322.06Zm.28-.62a4.82,4.82,0,0,0,2.4-2.31.73.73,0,0,0-.28-.74.25.25,0,0,0-.27-.08,1,1,0,0,0-.26.16A9.46,9.46,0,0,0,250.53,321.44Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19,322.11a.2.2,0,0,1-.21-.06c-.11-.1-1.66-2.06-1.41-3.38a1.3,1.3,0,0,1,.54-.81.72.72,0,0,1,.9-.09c.81.58.71,3.2.31,4.2l0,.1Zm-.89-3.85a.86.86,0,0,0-.27.47c-.16.84.62,2.1,1,2.7.26-1.12.18-3-.3-3.29-.05,0-.15-.11-.39.06l-.08.06Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.96 330.3 240.66 330.31 247.71 330.32 248.55 322.89 242.03 322.02 226.09 319.89 225.96 330.3",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,322l-1.79,8.47a.85.85,0,0,0,.69,1l4.22.76s5.61,1.43,7.19.42c4.6-2.94,9-21.59,7.16-23-.68-.5-1.87.26-2.46.87-1.89,1.93-5.92,7.31-7.52,8.91-1.86,1.86-5.17,1.91-6.62,1.84A.85.85,0,0,0,247,322Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.96 330.3 240.66 330.31 242.03 322.02 226.09 319.89 225.96 330.3",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.45,297.71v1.86a2.41,2.41,0,0,0,2.3,2.4h68.39a2.56,2.56,0,0,0,2.47-2.4v-1.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.45,297.71v1.86a2.41,2.41,0,0,0,2.3,2.4h68.39a2.56,2.56,0,0,0,2.47-2.4v-1.86Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,297.71v1.86a2.42,2.42,0,0,0,2.31,2.4h42.86a2.56,2.56,0,0,0,2.47-2.4v-1.86Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.28,300.26h45.18a3.7,3.7,0,0,0,3.29-2.42l10.36-32.5a1.8,1.8,0,0,0-1.74-2.51H210.19a3.76,3.76,0,0,0-3.28,2.51L196.55,297.8A1.76,1.76,0,0,0,198.28,300.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.28,300.26h45.18a3.7,3.7,0,0,0,3.29-2.42l10.36-32.5a1.8,1.8,0,0,0-1.74-2.51H210.19a3.76,3.76,0,0,0-3.28,2.51L196.55,297.8A1.76,1.76,0,0,0,198.28,300.26Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,300.26h43.48a3.7,3.7,0,0,0,3.29-2.42l10.36-32.5a1.8,1.8,0,0,0-1.74-2.51H211.89a3.76,3.76,0,0,0-3.28,2.51L198.25,297.8A1.76,1.76,0,0,0,200,300.26Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.42,283c-.56,2.16.52,3.92,2.41,3.92s3.86-1.76,4.42-3.92-.52-3.92-2.4-3.92S227,280.87,226.42,283Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,322l-1.79,8.47a.85.85,0,0,0,.69,1l4.22.76s5.61,1.43,7.19.42c4.6-2.94,9-21.59,7.16-23-.68-.5-1.87.26-2.46.87-1.89,1.93-5.92,7.31-7.52,8.91-1.86,1.86-5.17,1.91-6.62,1.84A.85.85,0,0,0,247,322Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "150.26 289.99 136.08 290.17 136.35 285.56 150.26 285.26 150.26 289.99"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "178.24 284.65 182.48 284.56 184 289.54 178.24 289.62 178.24 284.65"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "176.43 284.69 176.43 289.64 152.44 289.96 152.44 285.21 176.43 284.69"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M162.61,288.78l-.07-1.93a1.9,1.9,0,0,1,1.75-2l4.34-.18a1.77,1.77,0,0,1,1.31.51,2,2,0,0,1,.59,1.36l.07,1.92a1.91,1.91,0,0,1-1.76,2l-4.33.18h-.08A1.89,1.89,0,0,1,162.61,288.78Zm6.2.87a1.11,1.11,0,0,0,1-1.18l-.07-1.92a1.2,1.2,0,0,0-.35-.79,1,1,0,0,0-.76-.3l-4.34.18a1.1,1.1,0,0,0-1,1.18l.07,1.93a1.09,1.09,0,0,0,1.11,1.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.35,288.15h2.18a.51.51,0,0,0,.5-.5.5.5,0,0,0-.5-.5h-2.18a.5.5,0,0,0-.5.5A.51.51,0,0,0,163.35,288.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.3,237.2s-5.47,34.59-3.18,47l-50.59,1.47s6-35.73,13.95-49.21C148.48,236.42,161.69,214.36,188.3,237.2Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.3,237.2s-5.47,34.59-3.18,47l-50.59,1.47s6-35.73,13.95-49.21C148.48,236.42,161.69,214.36,188.3,237.2Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.62,229.5s8.39,8.2,13.24,6.86,6.67-3.81,6.67-3.81-3.9-1.71-3.47-2.64c.05-.1.17-.29.34-.57,1.45-2.2,6.59-9.22,6.59-9.22l-11-6.19s-.9,2.13-2,4.67c-1.49,3.38-3.35,7.47-4,8.23C163.85,228.17,158.62,229.5,158.62,229.5Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.94,218.6c.69,3.9,2.39,8.49,6.46,10.74,1.45-2.2,6.59-9.22,6.59-9.22l-11-6.19S170.05,216.06,168.94,218.6Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.73,211a19.13,19.13,0,0,0-.89,6c.21,2.48-2.55,3.31-2.9,1.81,0,0,.05,3.65,2.42,3.1,0,0,0,2.53,2.12,2.57a14,14,0,0,0,2.66-8.57C169.81,211.1,166.73,211,166.73,211Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.74,198.84c-3.6,1.49-3,9.85,3,17,3.67-3.16,5.34-10.46,4.47-13.34C191.81,197.89,188.87,197.55,185.74,198.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,219.19v0a25.1,25.1,0,0,1-1.14,2.8c-3.55,7.23-13.76,8.64-18.28,1.49l-.05-.07c-3-4.82-1.87-9.31-.62-17.1a10.77,10.77,0,0,1,16.81-7.22C193.61,203.24,193.26,212.54,191,219.19Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.88,211c-.14.63.08,1.21.48,1.3s.85-.34,1-1-.07-1.21-.48-1.3S182.06,210.42,181.88,211Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,212.63c-.14.62.08,1.2.49,1.29s.85-.33,1-1-.08-1.21-.49-1.3S189.12,212,189,212.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.59,212.4a23.06,23.06,0,0,0,1.79,6,3.67,3.67,0,0,1-3.11-.12Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.44,208.35a.41.41,0,0,1-.22-.1.39.39,0,0,1,0-.54,3.71,3.71,0,0,1,3.33-.84.36.36,0,0,1,.26.44v0a.39.39,0,0,1-.47.26h0a2.94,2.94,0,0,0-2.62.69A.38.38,0,0,1,180.44,208.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.75,211a.42.42,0,0,1-.29-.29,3,3,0,0,0-1.69-2.12.38.38,0,0,1-.23-.48.38.38,0,0,1,.48-.23,3.73,3.73,0,0,1,2.17,2.66.37.37,0,0,1-.27.45h0A.42.42,0,0,1,192.75,211Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.79,222.12h0a5.74,5.74,0,0,1-4.8-3.66.28.28,0,0,1,.19-.34.29.29,0,0,1,.35.19c0,.11.82,2.65,4.35,3.26a.29.29,0,0,1,.23.32A.28.28,0,0,1,183.79,222.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.51,205.07s2.32-1.78,2.23-3.86a7.65,7.65,0,0,0-4.08-6.31,14.87,14.87,0,0,0-7.27-2c-8.86-.52-13.68,2.14-15.2,6.87-.94,1.68-.92,4.8-.08,7.72a.09.09,0,0,1,0,.05h0a12.84,12.84,0,0,0,2.31,4.58c5.4-4.68,7.41-8,6.56-10.2.18-.05,2.86-2.45,4.05-2.51,1.72-.09,4.89,1.54,7.46,3.07,1.41.83,2.86-.5,2.86-.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.85,211.67a7.48,7.48,0,0,0,2.49,5.16c2,1.72,4.1.22,4.49-2.23.36-2.21-.24-5.78-2.68-6.56S165.71,209.24,165.85,211.67Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.84,216.93s3.28-12.75,11.39-17.5S193.75,198,193.75,198a25.52,25.52,0,0,0-.55-3.8c-.24-.4-4.26-1.78-4.26-1.78s-2.29-3.37-5.47-4.45-12.68-1.39-16,1.38-5.51,8.41-4.11,8.51,2.47.1,2.47.1-2.62,9.05-1.5,10.41C164.34,208.36,162.4,214.66,165.84,216.93Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.11,333.74a.25.25,0,0,1,.23-.1.16.16,0,0,1,.14.16c.08.38.6,3.76-.24,4.59a.71.71,0,0,1-.68.14,1.14,1.14,0,0,1-.86-.78,3,3,0,0,1,.22-1.83A12.13,12.13,0,0,1,182.11,333.74Zm0,.69a4.8,4.8,0,0,0-1,3.16.72.72,0,0,0,.59.52.24.24,0,0,0,.27-.05.71.71,0,0,0,.16-.26A9.31,9.31,0,0,0,182.14,334.43Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.49 317.19 190.55 321.82 183.85 324.05 185.4 331.36 191.87 330.13 207.66 327.11 204.49 317.19",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.21,331.74l-1-8.6a.86.86,0,0,0-1-.76L181,323s-5.77.42-6.95,1.87c-3.44,4.25-1.75,23.34.47,24.06.81.26,1.69-.84,2.06-1.6,1.18-2.43,3.31-8.81,4.31-10.83,1.18-2.35,4.3-3.45,5.7-3.84A.85.85,0,0,0,187.21,331.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.14,333.68a.18.18,0,0,1,.22,0c.13,0,2.42,1,2.81,2.33a1.22,1.22,0,0,1-.1,1,.72.72,0,0,1-.75.49c-1-.13-2.12-2.5-2.23-3.56l0-.11A.18.18,0,0,1,182.14,333.68Zm2.58,3a.83.83,0,0,0,0-.54c-.24-.82-1.52-1.57-2.17-1.9.29,1.11,1.22,2.7,1.8,2.77.06,0,.18,0,.31-.24l.05-.09Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.49 317.19 190.55 321.82 191.87 330.13 207.66 327.11 204.49 317.19",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.29 331.42 198.27 331.79 195.89 318.04 191.32 320.44 194.29 331.42",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.29 331.42 198.27 331.79 195.89 318.04 191.32 320.44 194.29 331.42",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.21,331.74l-1-8.6a.86.86,0,0,0-1-.76L181,323s-5.77.42-6.95,1.87c-3.44,4.25-1.75,23.34.47,24.06.81.26,1.69-.84,2.06-1.6,1.18-2.43,3.31-8.81,4.31-10.83,1.18-2.35,4.3-3.45,5.7-3.84A.85.85,0,0,0,187.21,331.74Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.32,320.94s-65.24-25.34-85.21-21.11-20.08,14.69-10,24.44,25.26,6,25.26,6-11.89-7.12-11.06-11.52,8.39,5.66,8.39,5.66,39.42,9.64,72,7.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.11 319.88 236.45 318.2 234.34 331.93 239.44 331.1 240.11 319.88",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.11 319.88 236.45 318.2 234.34 331.93 239.44 331.1 240.11 319.88",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.48,226.84s8.83,24,8.37,29.39S144.2,302,144.2,302l-15,6S132.29,248.69,154.48,226.84Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.48,226.84s8.83,24,8.37,29.39S144.2,302,144.2,302l-15,6S132.29,248.69,154.48,226.84Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.35,296.51s-4.72-11.19-6.23-17.39,3.77-38.05.93-48.74l7.25,6.82L185.23,277Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.35,296.51s-4.72-11.19-6.23-17.39,3.77-38.05.93-48.74l7.25,6.82L185.23,277Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.82,279.12s31.29,6,26.34-51.16l-5.09-.44s3.1,21.72-2.61,35.93S132.29,277,132.29,277Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.67,253.72l-10.5-24.38L149,233.53s-.56-5.91,1.28-7.63,7,.43,9,.94S162.67,253.72,162.67,253.72Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.22,230.76s4.05,12,3.39,30.78,2.72,17.22,2.72,17.22l.48-1.77s-1.89-.22-1.74-6.55,1-31.88-1.46-38.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.34,253s1-18-4.06-23.27c0,0,3.79-1.42,5.33,0s1.92,15.13-1.1,24",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.93,260.36s4.58,10.63,5.61,12.11,23.82,12,23.82,12a20.25,20.25,0,0,1,5.57,0c2.81.44,6.68,1.62,7,2.07s-4.23,7.09-4.23,7.09-9.11.56-10.24-3c0,0-22.84-8.48-25.49-10.7S148,264.49,148,264.49Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.26,236.51c4.88,0,11.73,29.79,13,33.83S184.77,283,184.77,283l-6.43,7.61s-21.88-7.9-24.45-11.53S143.53,254.78,143.17,250,147,236.5,150.26,236.51Z",
    style: {
      fill: "#00A848"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignin);
export default __webpack_public_path__ + "static/media/signin.c9aa3392bc6cafd00028df05bf9cd8f8.svg";
export { ForwardRef as ReactComponent };